/**
 * @generated SignedSource<<fe8fa3ba884375546ddf7fd4b58e893a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Tile_kpiTileGraphSlider$data = {
  readonly parts: number;
  readonly " $fragmentType": "Tile_kpiTileGraphSlider";
};
export type Tile_kpiTileGraphSlider$key = {
  readonly " $data"?: Tile_kpiTileGraphSlider$data;
  readonly " $fragmentSpreads": FragmentRefs<"Tile_kpiTileGraphSlider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tile_kpiTileGraphSlider",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parts",
      "storageKey": null
    }
  ],
  "type": "WidgetKPITileGraphSlider",
  "abstractKey": null
};

(node as any).hash = "5be156d1a917bcd6c4dc368e346d15d2";

export default node;
